import axios from "axios";

export class MeetingService {
  async joinMeeting(roomId: number, pinToJoin: number | null): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/join_meeting`, { pinToJoin });
  }
  async leaveRoomMeeting(roomId: number): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/leave_meeting`, {});
  }
  async createMeetingOneToOne(userId: number): Promise<any> {
    return await axios.post(`api/space_users/${userId}/meet`, {});
  }
  async joinMeetingOneToOne(meetingId: number): Promise<any> {
    return await axios.post(`api/meetings/${meetingId}/join`, {});
  }
  async closeMeetingOneToOne(meetingId: number, attendee): Promise<any> {
    return await axios.post(
      `api/meetings/${meetingId}/attendee/${attendee}`,
      {}
    );
  }
  async openWebinar(roomId: number): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/open_webinar`, {});
  }
  async closeWebinar(roomId: number): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/close_webinar`, {});
  }
  async changeVideoUrl(roomId: number, data): Promise<any> {
    return await axios.put(`api/rooms/${roomId}/change_video_url`, data);
  }
  async createPoll(roomId: number, data): Promise<any> {
    return await axios.post(`api/room/${roomId}/poll`, data);
  }
  async votePoll(pollOption: number): Promise<any> {
    return await axios.post(`api/poll_options/${pollOption}/vote`, {});
  }
  async cancelPoll(pollId: number): Promise<any> {
    return await axios.put(`api/polls/${pollId}/close`, {});
  }
  async startAutoVideo(roomId: number): Promise<any> {
    return await axios.post(`api/auto_videos/room/${roomId}/start`, {});
  }
  async stoptAutoVideo(autoVideoId: number): Promise<any> {
    return await axios.post(`api/auto_videos/${autoVideoId}/stop`, {});
  }
  async validateAutoVideo(autoVideoId: number, data: any): Promise<any> {
    return await axios.post(`api/auto_videos/${autoVideoId}/validate`, data);
  }
}
